/*
.js-destroyParentを押すと親の.js-destroyParent-frameを消す

<div class="js-destroyParent-frame"> ←この範囲が消える
  <button type="button" class="js-destroyParent">
    削除
  </button>
</div>
*/
window.addEventListener('click', function (e) {
  const item = e.target.closest('.js-destroyParent')
  if (!item) {
    return
  }
  applyDestroyParent(item)
})

function applyDestroyParent(item) {
  const target = item.closest('.js-destroyParent-frame')

  if (target) {
    target.remove() // DOM削除
  }
}
